module.exports = __webpack_public_path__ + "img/cat_half.6f2816cd.svg";